<template>
  <div class="maintenance-container">
    <!-- 3D Tilted Motherboard Board Scene -->
    <div class="scene-3d-wrapper">
      <!-- Fullscreen Motherboard Background Circuit Layer -->
      <svg class="bg-circuit-svg" viewBox="0 0 2400 1200" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice">
        <defs>
          <!-- Mask to ease background circuit line ends smoothly into dark gray motherboard bg -->
          <mask id="bgCircuitFadeMask">
            <rect width="2400" height="1200" fill="url(#maskRadialGrad)" />
          </mask>
          <radialGradient id="maskRadialGrad" cx="50%" cy="50%" r="50%">
            <stop offset="25%" stop-color="#ffffff" stop-opacity="1" />
            <stop offset="65%" stop-color="#ffffff" stop-opacity="0.75" />
            <stop offset="88%" stop-color="#ffffff" stop-opacity="0.25" />
            <stop offset="100%" stop-color="#ffffff" stop-opacity="0" />
          </radialGradient>
        </defs>

        <!-- Black Circuit Traces & Bus Lines on Dark Gray Motherboard -->
        <g stroke="#000000" fill="none" stroke-linecap="round" stroke-linejoin="round" opacity="0.9" mask="url(#bgCircuitFadeMask)">
          <!-- Main Horizontal & Vertical Bus Traces (Thick lines) -->
          <g stroke-width="3.5">
            <!-- Top Left to Center-Right Bus lines -->
            <path d="M 0 60 H 600 L 680 140 H 1550 L 1620 210 H 2400" />
            <path d="M 0 75 H 590 L 670 155 H 1540 L 1610 225 H 2400" />
            <path d="M 0 90 H 580 L 660 170 H 1530 L 1600 240 H 2400" />
            <path d="M 0 105 H 570 L 650 185 H 1520 L 1590 255 H 2400" />

            <!-- Mid Left to Mid Right Bus lines -->
            <path d="M 300 -50 V 180 L 360 240 V 650 L 420 710 V 1250" />
            <path d="M 315 -50 V 170 L 275 230 V 640 L 435 700 V 1250" />
            <path d="M 330 -50 V 160 L 290 220 V 630 L 450 690 V 1250" />

            <!-- Top Right to Center-Left Bus lines -->
            <path d="M 2400 80 H 1800 L 1720 160 H 1050 L 970 240 H 0" />
            <path d="M 2400 95 H 1790 L 1710 175 H 1040 L 960 255 H 0" />
            <path d="M 2400 110 H 1780 L 1700 190 H 1030 L 950 270 H 0" />
            <path d="M 2400 125 H 1770 L 1690 205 H 1020 L 940 285 H 0" />

            <!-- Bottom Bus line sets -->
            <path d="M 0 850 H 500 L 650 700 H 1750 L 1900 850 H 2400" />
            <path d="M 0 865 H 490 L 640 715 H 1740 L 1890 865 H 2400" />
            <path d="M 0 880 H 480 L 630 730 H 1730 L 1880 880 H 2400" />
            <path d="M 0 895 H 470 L 620 745 H 1720 L 1870 895 H 2400" />

            <!-- Right side vertical bus -->
            <path d="M 2050 -50 V 350 L 1950 450 V 700 L 2050 800 V 1250" />
            <path d="M 2065 -50 V 340 L 1965 440 V 690 L 2065 790 V 1250" />
            <path d="M 2080 -50 V 330 L 1975 430 V 680 L 2080 780 V 1250" opacity="0.9" />
          </g>

          <!-- Secondary Interconnect Circuit Lines (Medium lines) -->
          <g stroke-width="2" stroke="#08080a">
            <path d="M 120 -50 V 300 L 200 380 H 620 L 700 460 V 1250" />
            <path d="M 135 -50 V 290 L 215 370 H 630 L 710 450 V 1250" />
            <path d="M 150 -50 V 280 L 230 360 H 640 L 720 440 V 1250" />

            <path d="M 2280 -50 V 250 L 2180 350 H 1450 L 1350 450 V 1250" />
            <path d="M 2295 -50 V 240 L 2195 340 H 1460 L 1360 440 V 1250" />
            <path d="M 2310 -50 V 230 L 2210 330 H 1470 L 1370 430 V 1250" />

            <path d="M 0 450 H 320 L 420 550 H 1080 L 1180 450 H 2400" />
            <path d="M 0 465 H 310 L 410 565 H 1070 L 1170 465 H 2400" />

            <path d="M 0 600 H 250 L 350 500 H 850 L 950 600 H 1450 L 1550 500 H 2400" />
            <path d="M 0 615 H 240 L 340 515 H 840 L 940 615 H 1440 L 1540 515 H 2400" />

            <path d="M 800 -50 V 120 L 700 220 H 250 L 170 300 V 650 L 250 730 H 780 L 860 810 V 1250" />
            <path d="M 1250 -50 V 180 L 1150 280 H 1000 L 900 380 V 580 L 1000 680 H 1380 L 1460 760 V 1250" />
            <path d="M 1650 -50 V 140 L 1550 240 H 1400 L 1320 320 V 620 L 1400 700 H 1780 L 1860 780 V 1250" />
          </g>

          <!-- Fine Circuit Branch Leads (Thin detail lines) -->
          <g stroke-width="1.2" stroke="#050506">
            <path d="M 100 200 L 150 250 H 450" />
            <path d="M 2200 200 L 2150 250 H 1800" />
            <path d="M 1000 800 L 1050 850 H 1350 L 1400 900" />
            <path d="M 500 950 L 550 1000 H 850" />
            <path d="M 1600 950 L 1650 1000 H 1950" />
            <path d="M 1100 150 L 1150 200 H 1350" />
            <path d="M 750 150 L 700 200 H 500" />
            <path d="M 400 500 L 450 550 V 750" />
            <path d="M 1900 500 L 1850 550 V 750" />
          </g>

          <!-- Black Solder Vias (Circuit Nodes at Junctions) -->
          <g fill="#000000" stroke="#18191c" stroke-width="1.5">
            <circle cx="600" cy="60" r="4" /><circle cx="680" cy="140" r="4" /><circle cx="1550" cy="140" r="4" />
            <circle cx="590" cy="75" r="4" /><circle cx="670" cy="155" r="4" /><circle cx="1540" cy="155" r="4" />
            <circle cx="580" cy="90" r="4" /><circle cx="660" cy="170" r="4" /><circle cx="1530" cy="170" r="4" />

            <circle cx="1800" cy="80" r="4" /><circle cx="1720" cy="160" r="4" /><circle cx="1050" cy="160" r="4" />
            <circle cx="1790" cy="95" r="4" /><circle cx="1710" cy="175" r="4" /><circle cx="1040" cy="175" r="4" />

            <circle cx="500" cy="850" r="4" /><circle cx="650" cy="700" r="4" /><circle cx="1750" cy="700" r="4" />
            <circle cx="490" cy="865" r="4" /><circle cx="640" cy="715" r="4" /><circle cx="1740" cy="715" r="4" />

            <circle cx="360" cy="240" r="4" /><circle cx="420" cy="710" r="4" />
            <circle cx="1950" cy="450" r="4" /><circle cx="2050" cy="800" r="4" />
            <circle cx="200" cy="380" r="4" /><circle cx="700" cy="460" r="4" />
            <circle cx="2180" cy="350" r="4" /><circle cx="1350" cy="450" r="4" />
            <circle cx="420" cy="550" r="4" /><circle cx="1180" cy="450" r="4" />
            <circle cx="350" cy="500" r="4" /><circle cx="950" cy="600" r="4" />
            <circle cx="150" cy="250" r="3.5" /><circle cx="450" cy="250" r="3.5" />
            <circle cx="2150" cy="250" r="3.5" /><circle cx="1800" cy="250" r="3.5" />
            <circle cx="1050" cy="850" r="3.5" /><circle cx="1350" cy="850" r="3.5" />
            <circle cx="550" cy="1000" r="3.5" /><circle cx="850" cy="1000" r="3.5" />
            <circle cx="1650" cy="1000" r="3.5" /><circle cx="1950" cy="1000" r="3.5" />
          </g>
        </g>
      </svg>

      <!-- Center Circuit Text Container -->
      <div class="circuit-wrapper">
        <svg class="circuit-text-svg" viewBox="0 0 1200 420" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <!-- Copper Gradients -->
            <linearGradient id="copperLineGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stop-color="#fcd3a8" />
              <stop offset="35%" stop-color="#e28c46" />
              <stop offset="75%" stop-color="#964b15" />
              <stop offset="100%" stop-color="#e89853" />
            </linearGradient>

            <!-- Metallic Silver Solder Gradients -->
            <linearGradient id="silverSolderGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stop-color="#ffffff" />
              <stop offset="30%" stop-color="#e2e8f0" />
              <stop offset="65%" stop-color="#94a3b8" />
              <stop offset="100%" stop-color="#475569" />
            </linearGradient>

            <radialGradient id="silverViaHoleGrad" cx="50%" cy="50%" r="50%">
              <stop offset="0%" stop-color="#1e293b" />
              <stop offset="65%" stop-color="#0f172a" />
              <stop offset="100%" stop-color="#e2e8f0" />
            </radialGradient>

            <!-- 3D Text Bump Shadow & Glow Filter -->
            <filter id="circuitBumpShadow" x="-20%" y="-20%" width="150%" height="150%">
              <feDropShadow dx="3" dy="6" stdDeviation="4" flood-color="#000000" flood-opacity="0.9" />
              <feDropShadow dx="-1" dy="-1" stdDeviation="1.5" flood-color="#ffebd0" flood-opacity="0.35" />
              <feGaussianBlur stdDeviation="3" result="blur" />
              <feComposite in="SourceGraphic" in2="blur" operator="over" />
            </filter>

            <filter id="solder3dShadow" x="-30%" y="-30%" width="160%" height="160%">
              <feDropShadow dx="2" dy="4" stdDeviation="2.5" flood-color="#000000" flood-opacity="0.85" />
            </filter>
          </defs>

          <!-- 3D Bump Shadow Layer under Copper Circuit Traces -->
          <g stroke="#000000" fill="none" stroke-linecap="round" stroke-linejoin="round" opacity="0.75" transform="translate(4, 7)">
            <g stroke-width="10">
              <path d="M 60 70 V 250 M 60 70 H 150 M 60 160 H 130" />
              <path d="M 190 70 V 250 M 190 70 H 280 M 190 160 H 260 M 190 250 H 280" />
              <path d="M 320 70 V 250 M 320 70 H 400 L 415 85 V 135 L 400 150 H 320 M 360 150 L 415 235 V 250" />
              <path d="M 455 160 H 515" />
              <path d="M 550 70 H 670 M 610 70 V 250" />
              <path d="M 700 70 V 250 M 700 70 H 790 M 700 160 H 770 M 700 250 H 790" />
              <path d="M 910 70 H 835 L 820 85 V 235 L 835 250 H 910" />
              <path d="M 940 70 V 250 M 1040 70 V 250 M 940 160 H 1040" />
            </g>
          </g>

          <!-- Main PCB Circuit Traces forming FER-TECH -->
          <g stroke="url(#copperLineGrad)" fill="none" stroke-linecap="round" stroke-linejoin="round" filter="url(#circuitBumpShadow)">

            <!-- Outer Main Traces (Thick Copper Lines) -->
            <g stroke-width="9">
              <!-- F -->
              <path d="M 60 70 V 250 M 60 70 H 150 M 60 160 H 130" />
              <!-- E -->
              <path d="M 190 70 V 250 M 190 70 H 280 M 190 160 H 260 M 190 250 H 280" />
              <!-- R -->
              <path d="M 320 70 V 250 M 320 70 H 400 L 415 85 V 135 L 400 150 H 320 M 360 150 L 415 235 V 250" />
              <!-- - (Hyphen) -->
              <path d="M 455 160 H 515" />
              <!-- T -->
              <path d="M 550 70 H 670 M 610 70 V 250" />
              <!-- E -->
              <path d="M 700 70 V 250 M 700 70 H 790 M 700 160 H 770 M 700 250 H 790" />
              <!-- C -->
              <path d="M 910 70 H 835 L 820 85 V 235 L 835 250 H 910" />
              <!-- H -->
              <path d="M 940 70 V 250 M 1040 70 V 250 M 940 160 H 1040" />
            </g>

            <!-- Inner Secondary Circuit Traces (Thin parallel lines) -->
<!--            <g stroke-width="3" stroke="#ffe3cb" opacity="0.95">
              &lt;!&ndash; F &ndash;&gt;
              <path d="M 72 82 V 238 M 72 82 H 140 M 72 160 H 120" />
              &lt;!&ndash; E &ndash;&gt;
              <path d="M 202 82 V 238 M 202 82 H 270 M 202 160 H 250 M 202 238 H 270" />
              &lt;!&ndash; R &ndash;&gt;
              <path d="M 332 82 V 238 M 332 82 H 392 L 403 93 V 127 L 392 138 H 332 M 372 150 L 403 223 V 238" />
              &lt;!&ndash; - &ndash;&gt;
              <path d="M 465 160 H 505" />
              &lt;!&ndash; T &ndash;&gt;
              <path d="M 560 82 H 660 M 610 82 V 238" />
              &lt;!&ndash; E &ndash;&gt;
              <path d="M 712 82 V 238 M 712 82 H 780 M 712 160 H 760 M 712 238 H 780" />
              &lt;!&ndash; C &ndash;&gt;
              <path d="M 900 82 H 843 L 832 93 V 227 L 843 238 H 900" />
              &lt;!&ndash; H &ndash;&gt;
              <path d="M 952 82 V 238 M 1028 82 V 238 M 952 160 H 1028" />
            </g>-->

            <!-- Additional 45° Corner PCB Lead Connections -->
            <g stroke-width="2.5" stroke="#f7b783" opacity="0.8">
              <path d="M 40 160 L 60 160 M 150 70 L 165 55 M 130 160 L 145 145" />
              <path d="M 280 70 L 295 55 M 260 160 L 275 145 M 280 250 L 295 265" />
              <path d="M 415 250 L 430 265 M 515 160 L 530 145" />
              <path d="M 550 70 L 535 55 M 670 70 L 685 55 M 610 250 L 610 270" />
              <path d="M 790 70 L 805 55 M 770 160 L 785 145 M 790 250 L 805 265" />
              <path d="M 910 70 L 925 55 M 910 250 L 925 265" />
              <path d="M 940 70 L 925 55 M 1040 70 L 1055 55 M 1040 250 L 1055 265" />
            </g>

          </g>

          <!-- Silver Solder Vias & Component Joint Pads with 3D Bump Shadow -->
          <g fill="url(#silverSolderGrad)" stroke="#334155" stroke-width="1.8" filter="url(#solder3dShadow)">
            <!-- F Vias -->
            <circle cx="60" cy="70" r="7.5" /><circle cx="60" cy="250" r="7.5" />
<!--            <circle cx="150" cy="70" r="7.5" /><circle cx="130" cy="160" r="7.5" />-->
<!--            <circle cx="60" cy="160" r="5" fill="url(#silverViaHoleGrad)" stroke="#cbd5e1" stroke-width="2" />-->

            <!-- E Vias -->
<!--            <circle cx="190" cy="70" r="7.5" /><circle cx="190" cy="250" r="7.5" />-->
<!--            <circle cx="280" cy="70" r="7.5" />--><circle cx="260" cy="160" r="7.5" />
<!--            <circle cx="280" cy="250" r="7.5" />-->
<!--            <circle cx="190" cy="160" r="5" fill="url(#silverViaHoleGrad)" stroke="#cbd5e1" stroke-width="2" />-->

            <!-- R Vias -->
<!--            <circle cx="320" cy="70" r="7.5" />--><circle cx="320" cy="250" r="7.5" />
            <circle cx="400" cy="70" r="6.5" /><!--<circle cx="415" cy="85" r="6.5" />-->
<!--            <circle cx="415" cy="135" r="6.5" /><circle cx="400" cy="150" r="6.5" />-->
<!--            <circle cx="415" cy="250" r="7.5" />-->
            <circle cx="320" cy="150" r="5" fill="url(#silverViaHoleGrad)" stroke="#cbd5e1" stroke-width="2" />
            <circle cx="360" cy="150" r="5" fill="url(#silverViaHoleGrad)" stroke="#cbd5e1" stroke-width="2" />

            <!-- Hyphen Vias -->
            <circle cx="455" cy="160" r="7.5" /><circle cx="515" cy="160" r="7.5" />

            <!-- T Vias -->
            <circle cx="550" cy="70" r="7.5" /><circle cx="670" cy="70" r="7.5" />
            <circle cx="610" cy="250" r="7.5" />
            <circle cx="610" cy="70" r="5" fill="url(#silverViaHoleGrad)" stroke="#cbd5e1" stroke-width="2" />

            <!-- E Vias -->
<!--            <circle cx="700" cy="70" r="7.5" /><circle cx="700" cy="250" r="7.5" />
            <circle cx="790" cy="70" r="7.5" /><circle cx="770" cy="160" r="7.5" />-->
            <circle cx="790" cy="250" r="7.5" />
            <circle cx="700" cy="160" r="5" fill="url(#silverViaHoleGrad)" stroke="#cbd5e1" stroke-width="2" />

            <!-- C Vias -->
            <circle cx="910" cy="70" r="7.5" /><!--<circle cx="835" cy="70" r="6.5" />-->
<!--            <circle cx="820" cy="85" r="6.5" /><circle cx="820" cy="235" r="6.5" />-->
<!--            <circle cx="835" cy="250" r="6.5" /><circle cx="910" cy="250" r="7.5" />-->

            <!-- H Vias -->
            <circle cx="940" cy="70" r="7.5" /><!--<circle cx="940" cy="250" r="7.5" />-->
<!--            <circle cx="1040" cy="70" r="7.5" />--><!--<circle cx="1040" cy="250" r="7.5" />-->
            <circle cx="940" cy="160" r="5" fill="url(#silverViaHoleGrad)" stroke="#cbd5e1" stroke-width="2" />
            <circle cx="1040" cy="160" r="5" fill="url(#silverViaHoleGrad)" stroke="#cbd5e1" stroke-width="2" />

            <!-- Extension Silver Via Points -->
            <circle cx="165" cy="55" r="4.5" fill="url(#silverSolderGrad)" stroke="#475569" stroke-width="1" />
            <circle cx="145" cy="145" r="4.5" fill="url(#silverSolderGrad)" stroke="#475569" stroke-width="1" />
            <circle cx="295" cy="55" r="4.5" fill="url(#silverSolderGrad)" stroke="#475569" stroke-width="1" />
            <circle cx="275" cy="145" r="4.5" fill="url(#silverSolderGrad)" stroke="#475569" stroke-width="1" />
            <circle cx="295" cy="265" r="4.5" fill="url(#silverSolderGrad)" stroke="#475569" stroke-width="1" />
            <circle cx="430" cy="265" r="4.5" fill="url(#silverSolderGrad)" stroke="#475569" stroke-width="1" />
            <circle cx="530" cy="145" r="4.5" fill="url(#silverSolderGrad)" stroke="#475569" stroke-width="1" />
            <circle cx="535" cy="55" r="4.5" fill="url(#silverSolderGrad)" stroke="#475569" stroke-width="1" />
            <circle cx="685" cy="55" r="4.5" fill="url(#silverSolderGrad)" stroke="#475569" stroke-width="1" />
            <circle cx="610" cy="270" r="4.5" fill="url(#silverSolderGrad)" stroke="#475569" stroke-width="1" />
            <circle cx="805" cy="55" r="4.5" fill="url(#silverSolderGrad)" stroke="#475569" stroke-width="1" />
            <circle cx="785" cy="145" r="4.5" fill="url(#silverSolderGrad)" stroke="#475569" stroke-width="1" />
            <circle cx="805" cy="265" r="4.5" fill="url(#silverSolderGrad)" stroke="#475569" stroke-width="1" />
            <circle cx="925" cy="55" r="4.5" fill="url(#silverSolderGrad)" stroke="#475569" stroke-width="1" />
            <circle cx="925" cy="265" r="4.5" fill="url(#silverSolderGrad)" stroke="#475569" stroke-width="1" />
            <circle cx="1055" cy="55" r="4.5" fill="url(#silverSolderGrad)" stroke="#475569" stroke-width="1" />
            <circle cx="1055" cy="265" r="4.5" fill="url(#silverSolderGrad)" stroke="#475569" stroke-width="1" />
          </g>

          <!-- Maintenance Subtitle Text -->
          <text x="600" y="400" text-anchor="middle" fill="#e28c46" font-size="22" font-weight="600" letter-spacing="4" font-family="Lato" opacity="0.9">
            Strona w trakcie aktualizacji
          </text>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MaintenancePage'
}
</script>

<style scoped>
.maintenance-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;
  background: radial-gradient(circle at center, #282a30 0%, #1c1d22 50%, #121316 85%, #0a0b0d 100%);
  overflow: hidden;
  margin: 0;
  padding: 0;
  perspective: 1000px;
  perspective-origin: 50% 50%;
}

.scene-3d-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  transform-style: preserve-3d;
  animation: boardRotateIn 5s cubic-bezier(0.45, 0, 0.15, 1) forwards;
  filter: drop-shadow(0 30px 45px rgba(0, 0, 0, 0.8));
}

@keyframes boardRotateIn {
  from {
    transform: rotateX(45deg) rotateZ(15deg) scale(1.1);
  }
  to {
    transform: rotateX(0deg) rotateZ(0deg) scale(0.7);
  }
}

.bg-circuit-svg {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 2400px;
  max-width: none;
  height: 1200px;
  transform: translate(-50%, -50%);
  pointer-events: none;
  z-index: 0;
}

.circuit-wrapper {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1400px;
  padding: 2rem;
}

.circuit-text-svg {
  width: 100%;
  height: auto;
  user-select: none;
  filter: drop-shadow(0 0 35px rgba(217, 130, 59, 0.65));
}
</style>